module.exports = __webpack_public_path__ + "img/globe-nav-chevron-down-grey.9a12015d.svg";